<template>
    <!-- loading spinner -->
    <div v-if="!deviceDataLoaded" id="live-data-loading" style="text-align: center;">
        <div class="lds-facebook">
            <div></div>
            <div></div>
            <div></div>
        </div>
        <div>Connecting to live data feed...</div>
    </div>

    <div v-else-if="deviceDataLoaded" style="padding-top: 100px; text-align: center; min-width: 1000px; max-width: 1000px;">
        <div class="image-container" style="min-width: 1000px; max-width: 1000px;">
            <img style="width: 1000px;" src="../../assets/images/refrigeration-image-placeholder.png">
            <div class="motors_lc_pump_speedpv">{{motors_lc_pump_speedpv}}</div>
            <div class="pids_lc_flow_anlg_scaled">{{pids_lc_flow_anlg_scaled}}</div>
            <div class="analogs_lc_lst_scaled">{{analogs_lc_lst_scaled}}</div>
            <div class="analogs_lc_lrt_scaled">{{analogs_lc_lrt_scaled}}</div>
            <div class="motors_lc_pump_freqpv">{{motors_lc_pump_freqpv}}</div>
            <div class="analogs_ht_sct_scaled">{{analogs_ht_sct_scaled}}</div>
            <div class="motors_lc_pump_powerpv">{{motors_lc_pump_powerpv}}</div>
            <div class="motors_lc_pump_currentpv">{{motors_lc_pump_currentpv}}</div>
            <div class="analogs_lt_dst_scaled">{{analogs_lt_dst_scaled}}</div>
            <div class="analogs_lt_sct_scaled">{{analogs_lt_sct_scaled}}</div>
            <div class="analogs_lt_scp_scaled">{{analogs_lt_scp_scaled}}</div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'DeviceImageData',
        components: {
        },
        data: function () {
            return {
                deviceDataLoaded: false,
                refrigDataIntervalID: null,

                motors_lc_pump_speedpv: null,
                pids_lc_flow_anlg_scaled: null,
                analogs_lc_lst_scaled: null,
                analogs_lc_lrt_scaled: null,
                motors_lc_pump_freqpv: null,
                analogs_ht_sct_scaled: null,
                motors_lc_pump_powerpv: null,
                motors_lc_pump_currentpv: null,
                analogs_lt_dst_scaled: null,
                analogs_lt_sct_scaled: null,
                analogs_lt_scp_scaled: null,
            };
        },
        props: ['item'],
        async mounted() {
            var me = this;
            await me.getDeviceImageData();
            /* Priodically refresh data (currently set to every 5 seconds) */
            this.refrigDataIntervalID = window.setInterval(async function () {
                await me.getDeviceImageData();
            }, 10000)
        },
        beforeDestroy () {
            clearInterval(this.refrigDataIntervalID)
        },      
        methods: {
            async getDeviceImageData() {
                let url = process.env.VUE_APP_MULE_PROXY_API_URI;

                let headers = {
                    'Content-Type': 'application/json;charset=utf-8',
                    'authorization': localStorage.idtoken
                };
                
                var data = {
                    "endpoint": "/api/devices/" + this.item.id + "/data/refrigeration"
                };

                data = JSON.stringify(data);

                try {
                    const response = await this.$http.post(
                        url,
                        data,
                        { headers: headers }
                    );


                    for (var i = 0; i < response.data.length; i++) {
                        //response.data[i].id = response.data[i].TagPath.replace("/", "-");
                        var item = response.data[i];
                        this.pids_lc_flow_anlg_scaled = item.pids_lc_flow_anlg_scaled.toFixed(1)
                        this.analogs_lc_lst_scaled = item.analogs_lc_lst_scaled.toFixed(1)
                        this.analogs_lc_lrt_scaled = item.analogs_lc_lrt_scaled.toFixed(1)
                        this.motors_lc_pump_freqpv = item.motors_lc_pump_freqpv.toFixed(1)
                        this.analogs_ht_sct_scaled = item.analogs_ht_sct_scaled.toFixed(1)
                        this.motors_lc_pump_powerpv = item.motors_lc_pump_powerpv.toFixed(1)
                        this.motors_lc_pump_currentpv = item.motors_lc_pump_currentpv.toFixed(1)
                        this.analogs_lt_dst_scaled = item.analogs_lt_dst_scaled.toFixed(1)
                        this.analogs_lt_sct_scaled = item.analogs_lt_sct_scaled.toFixed(1)
                        this.analogs_lt_scp_scaled = item.analogs_lt_scp_scaled.toFixed(1)
                    }

                    this.deviceDataLoaded = true;
                } catch (error) {
                    console.log(error);
                }
            },
        }
    }
</script>

<style>
/* Container holding the image and the text */
.image-container {
  position: relative;
  text-align: center;
  font-size: large;
  font-weight: bold;
  /*color: white;*/
}


.pids_lc_flow_anlg_scaled
{
    position: absolute;
    top: 9%;
    left: 82%;
}

.analogs_lc_lst_scaled
{
    position: absolute;
    top: 9%;
    left: 68%;
}

.analogs_lc_lrt_scaled 
{
    position: absolute;
    top: 39%;
    left: 75%;
}

.analogs_ht_sct_scaled
{
    position: absolute;
    top: 62%;
    left: 24%;   
}

.motors_lc_pump_freqpv
{
    position: absolute;
    top: 56.5%;
    left: 75%;
}

.motors_lc_pump_powerpv
{
    position: absolute;
    top: 63.5%;
    left: 75%;
}

.motors_lc_pump_currentpv
{
    position: absolute;
    top: 71.5%;
    left: 75%;
}

.analogs_lt_dst_scaled
{
    position: absolute;
    top: 62%;
    left: 42.5%;
}

.analogs_lt_sct_scaled
{
    position: absolute;
    top: 62%;
    left: 54%;
}

.analogs_lt_scp_scaled
{
    position: absolute;
    top: 74%;
    left: 52.5%;
}
</style>